<template>
  <a-layout class="operationStatistics-body" style="height: 100%">
    <a-layout-sider
      width="360"
      style="background: #fff; min-width:360px; overflow:auto;"
      class="no-fix-sider"
    >
      <left-tree @search="(value) => seachValue(value)"></left-tree>
    </a-layout-sider>
    <div v-resize="'x'"></div>
    <a-layout-content style="height: 100%">
      <alarm-list
        @pageIndexchange="(value) => pageIndexchange(value)"
        :total="total"
        :filters="filter"
        :dataSource="dataSource"
        :advance="advance"
      ></alarm-list>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { AlarmHistoryServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
const ahsp = new AlarmHistoryServiceProxy()
import LeftTree from './components/leftTree.vue'
import AlarmList from './components/alarmList.vue'
export default {
  components: {
    LeftTree,
    AlarmList
  },
  data() {
    return {
      dataSource: [],
      total: 0,
      filter: {
        // 查询条件
        size: 50,
        current: 1
      },
      advance: {}
    }
  },
  methods: {
    pageIndexchange(value) {
      this.filter.current = value
      this.getList()
    },
    async seachValue(value) {
      this.filter.current = 1
      this.advance = value
      this.getList()
    },
    async getList() {
      const data = await ahsp.getPageAlarmHistory(
        this.advance,
        this.filter.current,
        this.filter.size
      )
      if (data.records && data.records.length) {
        this.dataSource = data.records.map((res, index) => {
          const add = { ...res }
          add.key = res.id + '/' + res.issueCode + '/' + res.deviceTypeId
          return add
        })
      } else {
        this.dataSource = []
      }
      this.total = data.total
    }
  }
}
</script>

<style lang="scss" scoped></style>
